// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CardMerchantInfoFeedbackSubmitFeedbackReportEvent
 */
export var CardMerchantInfoFeedbackSubmitFeedbackReport = function (_a) {
    var merchantToken = _a.merchantToken, parentMerchantToken = _a.parentMerchantToken, customerToken = _a.customerToken, transactionToken = _a.transactionToken, issueType = _a.issueType;
    return ({
        name: "CardMerchantInfoFeedback Submit FeedbackReport",
        parameters: {
            cdf_entity: "CardMerchantInfoFeedback",
            cdf_action: "Submit",
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            parent_merchant_token: parentMerchantToken !== undefined && parentMerchantToken !== null ? parentMerchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_token: transactionToken !== undefined && transactionToken !== null ? transactionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            issue_type: issueType !== undefined && issueType !== null ? issueType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
